import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { actionSetSelectedItem } from '../store/actions'

const useShouldSendRequest = (endpoint, initialState = false, callback) => {
  const dispatch = useDispatch()
  const [shouldLoading, setShouldLoading] = useState(initialState)

  useEffect(() => {
    if (shouldLoading && endpoint && endpoint.length) {
      axios.get(endpoint)
        .then(res => {
          if (typeof callback === 'function') callback(res.data)
          const action = actionSetSelectedItem(res.data)
          dispatch(action)
          setShouldLoading(false)
        }).catch((e) => {
        console.log(e)
      })
    }
  }, [])

  return shouldLoading
}

export default useShouldSendRequest
